
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ActionButtons extends Vue {
  @Prop({ required: true }) loading!: boolean;
  @Prop({ required: true }) isDealer!: boolean;
  @Prop({ required: true }) isEdited!: boolean;
  @Prop({ required: true }) isMarcaSelected!: boolean;
  @Prop({ default: false }) showResumen!: boolean;
  @Prop({ required: true }) hasAdmin!: boolean;
  @Prop({ default: true }) showExport!: boolean;

  L(text: string) {
    return text;
  }
}
